const getPropertyOfObj = <T, K extends keyof T>(obj: T, key: K) => {
    return obj[key]
}

// eslint-disable-next-line
const toBase64 = (file: any) => new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
})

/**
 * @param {Integer} ms
 * @returns {Float} hours'
 */
 const msToHours = (ms: number): number => {
    // let seconds = Math.floor((ms / 1000) % 60)
    // const minutes = Math.floor((ms / (1000 * 60)) % 60)
    const num = (ms / (1000 * 60 * 60)) % 24
    const hours = (Math.round(num * 100) / 100).toFixed(2)
    return Number(hours)
  }

/**
 * @param {string} time1 with format 'H:m:s'
 * @param {*} time2 with format 'H:m:s'
 * @returns {Integer} milliseconds of subtract times
 */
 const subtractTimeToDate = (time1: string, nextToDay = false) => {
    if (time1) {
      const t1 = time1.split(':')
      if (t1.length === 2) {
        t1.push('00')
      }
      if (t1.length === 3) {
        const tDate1 = new Date()
        if (nextToDay) {
          tDate1.setDate(tDate1.getDate() + 1)
        }
        tDate1.setHours(parseInt(t1[0]), parseInt(t1[1]), parseInt(t1[2]))
        // @ts-ignore
        return tDate1
      }
    }
    return null
  }

/**
 * @param {string} time1 with format 'H:m:s'
 * @param {*} time2 with format 'H:m:s'
 * @returns {Integer} milliseconds of subtract times
 */
const subtractTime = (time1: string, time2: string, nextToDay = false) => {
  if (time1 && time2) {
    const t1 = time1.split(':')
    const t2 = time2.split(':')
    if (t1.length === 2) {
      t1.push('00')
    }
    if (t2.length === 2) {
      t2.push('00')
    }
    if (t1.length === 3 && t2.length === 3) {
      const tDate1 = new Date()
      const tDate2 = new Date()
      if (nextToDay) {
        tDate2.setDate(tDate2.getDate() + 1)
      }
      tDate1.setHours(parseInt(t1[0]), parseInt(t1[1]), parseInt(t1[2]))
      tDate2.setHours(parseInt(t2[0]), parseInt(t2[1]), parseInt(t2[2]))
      // @ts-ignore
      return tDate2 - tDate1
    }
  }
  return 0
}

const formatAmount = (number: number) => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(number)
}

export {
    getPropertyOfObj,
    toBase64,
    subtractTime,
    msToHours,
    subtractTimeToDate,
    formatAmount
}
